import { useQuery } from 'react-query'
import { qaBackendApiInstance } from '../../config/config'

// Voices are fetched through our own backend wrapper (GET /video/voices) instead
// of hitting the ElevenLabs API directly with a client-side key. The backend
// returns the same structure as ElevenLabs ({ voices: [...] }), so call sites
// that read `data.voices` keep working. Auth is handled by the
// qaBackendApiInstance request interceptor (Bearer accessToken).
export const fetchVoiceDetails = async () => {
  try {
    const { data } = await qaBackendApiInstance.get('/video/voices')
    return data
  } catch (error) {
    console.error('Error fetching voice details:', error)
    throw error
  }
}

export const useGetVoices = () => {
  return useQuery(['GetVoices'], fetchVoiceDetails)
}

// Fetch a single voice's full details by id through our backend wrapper
// (GET /video/voices/:voiceId). Returns the ElevenLabs voice object
// ({ voice_id, name, labels, preview_url, ... }).
export const fetchVoiceById = async (voiceId: string) => {
  try {
    const { data } = await qaBackendApiInstance.get(`/video/voices/${voiceId}`)
    return data
  } catch (error) {
    console.error(`Error fetching voice ${voiceId}:`, error)
    throw error
  }
}
